export default "__VITE_ASSET__ClmjkVY1__"